export default __webpack_public_path__ + "static/media/shape.5274333d.shp";